import { Button, ButtonHierarchy } from '@/components/styleguide/Button'
import { Size } from '@/types/system'
import * as Sentry from '@sentry/nextjs'
import React from 'react'

export default class ComponentErrorBoundary extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      error: false,
    }
  }

  static getDerivedStateFromError() {
    return { error: true }
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope(scope => {
      scope.setExtras(errorInfo)
      const errorState = Sentry.captureException(error)
      this.setState({ error: errorState })
    })
  }

  reloadPage = () => {
    window.location.reload()
  }

  render() {
    const { error } = this.state
    if (error) {
      return (
        <>
          <div
            className="alert alert-warning m-3 text-center"
            role="alert">
            <p>
              Oops! Something went wrong.
              <br />
              Try reloading the page to correct this.
            </p>
          </div>
          <div className="mt-4 text-center">
            <Button
              onClick={() => this.reloadPage()}
              label="Reload Page"
              hierarchy={ButtonHierarchy.Filled}
              size={Size.Large}
            />
          </div>
        </>
      )
    }

    return this.props.children
  }
}
